/** Nombre de producto / módulo en UI (antes “Cámaras” / “sindicatos”). */
export const APP_NAME = 'CAMARAS';
export const APP_SHORT = 'CAMARAS';
/** Tarifa institucional asociada a DNI (texto visible). */
export const FEE_AGREEMENT_LABEL = 'Acuerdo CAMARAS';
/** Título compacto en la barra (estilo app móvil) */
export const PORTAL_APP_BAR = 'Portal de pagos';
export const APP_TAGLINE = 'Cobros institucionales con simulación de Mercado Pago';

export const ROLE = {
  SUPER_ADMIN:  'SuperAdmin',
  TENANT_ADMIN: 'TenantAdmin',
  OPERATOR:     'Operator',
} as const;

export type RoleName = typeof ROLE[keyof typeof ROLE];

export const FEE_CODE = {
  AGREEMENT:    'AGREEMENT',
  NO_AGREEMENT: 'NO_AGREEMENT',
} as const;
export type FeeCode = typeof FEE_CODE[keyof typeof FEE_CODE];

export const PAYMENT_STATUS = {
  APPROVED: 'APPROVED',
  PENDING:  'PENDING',
  REJECTED: 'REJECTED',
} as const;
export type PaymentStatus = typeof PAYMENT_STATUS[keyof typeof PAYMENT_STATUS];

export function fmtCurrency(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: currency || 'ARS',
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (_) {
    return `${currency || ''} ${amount.toFixed(2)}`;
  }
}
